import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {readCustomer} from "./erpHelper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import ReactLoading from "react-loading";
import {filterOptions} from "../../helper/invoiceHelper";
import Select from "../../local_node_modules/react-select";
import axios from "axios";
import {isValidInboxLine} from "../../common/componentValidation";
import {UncontrolledTooltip} from "reactstrap";
import CariModal from "./CariModal";
import ERPLineModal from "./ERPLineModal";

class SendToConnectorModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
			selectedList:[],
			inboxList:[],
			randomColorList:[],
			year:null,
			index:0,
			realIndex:0,
			error:{}
		};
		this.confirm     	= this.confirm.bind(this);
		this.onCancel     	= this.onCancel.bind(this);
		this.onChange    	= this.onChange.bind(this);
		this.createCari  	= this.createCari.bind(this);
		this.onCariChange   = this.onCariChange.bind(this);
		this.getRandomColor = this.getRandomColor.bind(this);
		this.validateMessage= this.validateMessage.bind(this);
		this.validateClass  = this.validateClass.bind(this);
		this.setCari  		= this.setCari.bind(this);
		this.setLine  		= this.setLine.bind(this);
	}

	componentDidMount = async()=> {
		let self = this;
		let params = {
			url: `/inbox/getErpLineList`,
			method: "post",
            data:{
				recordIdList:self.props.recordIdList,
				year: this.props.year
			}
		};

		try{
			self.setState({loading:true});
			const response = await request(params);
			let {inboxList,cariList,stockList} = response.data;
			cariList = cariList.result;

			let cariVknTcknList=[];
			let stockCodeList=[];
			let stockNameList=[];

			for(let i=0;i<cariList.length;i++){
				if(cariList[i].vknTckn)
					cariVknTcknList[cariList[i].vknTckn] = cariList[i];
			}
			for(let i=0;i<stockList.length;i++){
				if(stockList[i].itemCode)
					stockCodeList[stockList[i].itemCode] = stockList[i];

				if(stockList[i].edmItemName)
					stockNameList[stockList[i].edmItemName] = stockList[i];
			}

			for(let i=0;i<inboxList.length;i++){
				if(inboxList[i].vknTckn){
					if(cariVknTcknList[inboxList[i].vknTckn]){
						inboxList[i].cariCode=cariVknTcknList[inboxList[i].vknTckn].cariCode;
						inboxList[i].cariReferenceId=cariVknTcknList[inboxList[i].vknTckn].referenceId;
						inboxList[i].vknTckn=cariVknTcknList[inboxList[i].vknTckn].vknTckn;
						inboxList[i].success = true;
					}
				}
				let inboxLineList = inboxList[i].inboxLineList;
				for(let j=0;j<inboxLineList.length;j++){
					let flag = true;
					if(inboxLineList[j].edmItemName){
						if(stockNameList[inboxLineList[j].edmItemName]){
							inboxLineList[j].itemCode=	stockNameList[inboxLineList[j].edmItemName].itemCode;
							inboxLineList[j].itemName=	stockNameList[inboxLineList[j].edmItemName].itemName;
							inboxLineList[j].itemUnit=	stockNameList[inboxLineList[j].edmItemName].itemUnit;
							inboxLineList[j].stockReferenceId=stockNameList[inboxLineList[j].edmItemName].referenceId;
							inboxLineList[j].lineType=stockNameList[inboxLineList[j].edmItemName].lineType;
							inboxLineList[j].success = true;
							flag=false;
						}
					}
					if(flag){
						if(inboxLineList[j].itemCode){
							if(stockCodeList[inboxLineList[j].itemCode]){
								inboxLineList[j].itemName 	=stockCodeList[inboxLineList[j].itemCode].itemName;
								inboxLineList[j].itemUnit 	=stockCodeList[inboxLineList[j].itemCode].itemUnit;
								inboxLineList[j].stockReferenceId=	stockCodeList[inboxLineList[j].itemCode].referenceId;
								inboxLineList[j].edmItemName=stockCodeList[inboxLineList[j].itemCode].edmItemName;
								inboxLineList[j].lineType=stockCodeList[inboxLineList[j].itemCode].lineType;
								inboxLineList[j].success = true;
								flag=false;
							}
						}
					}
				}
				inboxList.inboxLineList = inboxLineList;
			}
			self.setState({inboxList,loading:false});

		}catch (error){
			showAxiosError(error);
			self.props.toggleModal(false,false);
		}
	}

	onChange(e,index){
		let inboxList = deepCopyObject(this.state.inboxList);
		inboxList[index][e.name]=e.value;
		this.setState({inboxList});
	}

	confirm(index){
		let self= this;
		this._source = axios.CancelToken.source();
		let inboxList = deepCopyObject(self.state.inboxList);
		if(index>=0 && index < inboxList.length){
			let inbox = inboxList[index];
			let result = isValidInboxLine(inbox.inboxLineList);
			let valid = result.valid;
			if (valid) {
				let params = {
					url: `/connector/writeInvoice/${self.props.year}/${self.props.month}`,
					method: 'post',
					cancelToken: self._source.token,
					data: deepCopyObject(inbox)
				};

				inbox.status = "processing";
				inboxList[index]=inbox;
				self.setState({confirmBtnDisabled:true,inboxList});
				request(params)
					.then(function (response) {
						let inbox = response.data;
						inbox.status = "success";
						inbox.success= true;
						inboxList[index]= inbox;
						self.setState({inboxList,index: (index+1)});
						if(index + 1 < inboxList.length){
							if((index+1) % 5 === 0){
								inboxList.splice(0,4);
								self.setState({index:index-4}, ()=>self.confirm((index+1)-4));
							}else{
								self.confirm(index+1);
							}
						}else{
							self.setState({confirmBtnDisabled:false,index: index+1}, ()=>self.props.toggleModal(true,false));
							return;
						}
					}).catch(function (error) {
					if (axios.isCancel(error)) {

					}else{
						inbox.status = "error";
						inboxList[index]= inbox;
						self.setState({inboxList,confirmBtnDisabled:false});
						showAxiosError(error);
					}
					return;
				});
			}else{
				self.setState({error:result.error,confirmBtnDisabled:false});
				Alert.error(result.errorMessage, {
					position: 'bottom-right',
					effect: 'stackslide',
					timeout: 3000,
					html:false
				});
			}
		}else{
			Alert.warning('Tüm dokümanlar gönderildi.', {
				position: 'bottom-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
			return;
		}
	}

	getRandomColor(documentUuid) {
		let {randomColorList} =  this.state;
		if(randomColorList[documentUuid]){
			return randomColorList[documentUuid];
		}else{
			randomColorList[documentUuid] = 'hsla(' + 360 * Math.random() + ', 50%, 50%)';
			this.setState({randomColorList});
			return randomColorList[documentUuid];
		}
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	createCari(option, index) {
		let {vknTckn,
			formattedName,
			referenceId,
			city,
			citySubdivision,
			country,
			phone,
			streetName,
			taxOffice
		} = this.state.inboxList[index];

		let cari = {
			vknTckn,
			formattedName,
			referenceId,
			city,
			citySubdivision,
			country,
			phone,
			streetName,
			taxOffice
		};
		this.setState({cari, cariModal: true, index});
	}

	onCariChange(data, index) {
		let self= this;
		if (data.hasOwnProperty("cari")) {
			let inboxList = deepCopyObject(this.state.inboxList);
			let cari = data.cari;
			inboxList[index].vknTckn=cari.vknTckn;
			inboxList[index].formattedName=cari.formattedName;
			inboxList[index].cariReferenceId=cari.referenceId;
			inboxList[index].cariCode=cari.cariCode;
			inboxList[index].success=true;
			self.setState({inboxList});
		}
	}

	onCancel(){
		if(this._source)
			this._source.cancel();

		if(this.state.index > 0){
			this.props.toggleModal(false,true);
		}else{
			this.props.toggleModal(false,false);
		}
	}

	getStatusRender(status) {
		let className =(status === "processing" ? "spinner fa-spin" : (status==="success" ? "check" :(status==="error" ? "close":"pause")));
		let color= (status === "processing" ? "dark" : (status==="success" ? "green" :(status==="error" ? "red":"dark")));
		return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
	}

	validateClass(id) {
		let {error} = this.state;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let {error} = this.state;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setCari(cari) {
		let {index,inboxList} = this.state;
		inboxList[index].vknTckn=cari.vknTckn;
		inboxList[index].formattedName=cari.formattedName;
		inboxList[index].cariReferenceId=cari.referenceId;
		inboxList[index].cariCode=cari.cariCode;
		inboxList[index].city=cari.city;
		inboxList[index].citySubdivision=cari.citySubdivision;
		inboxList[index].country=cari.country;
		inboxList[index].phone=cari.phone;
		inboxList[index].streetName=cari.streetName;
		inboxList[index].taxOffice=cari.taxOffice;
		inboxList[index].success=true;
		this.setState({inboxList,cariModal:false});
	}

	setLine(inboxLineList){
		let {inboxList,selectedIndex} = this.state;
		inboxList[selectedIndex].inboxLineList = inboxLineList;
		inboxList[selectedIndex].lineStatus=true;
		this.setState({inboxList,lineModal:false,selectedIndex:null});
	}

	render() {
		return (
			<DefaultModal disabled={this.state.loading || this.state.confirmBtnDisabled || (this.state.inboxList && this.state.inboxList.length ===0)}
						  isOpen={this.props.modal}
                          size="xl"
						  title={this.props.title || ""}
						  confirmBtnText="Gönder"
						  cancelBtnText="Kapat"
						  onConfirm={(e)=>this.confirm(this.state.index)}
						  onCancel={this.onCancel}
			>
				<div className="row">
					<div sm="12 "className="row col-sm-12" style={{marginLeft: '10px', paddingLeft: "5px"}}>
						{!this.state.loading &&
							<p className="text-success" style={{margin: '0px', padding: "0px"}}>* ERP'deki cari bilgisi ile eşleşti.&nbsp;&nbsp;</p>
						}
					</div>
					<div className="col-sm-12" style={{paddingBottom: '20px', maxHeight:'500px'}}>
						<table className="" style={{textAlign: 'center', paddingBottom:'200px'}}>
							<thead>
							<tr style={{backgroundColor: '#ebedf0'}}>
								<th width="6%">#</th>
								<th width="18%">Fatura No</th>
								<th width="20%">ERP Cari Kodu</th>
								<th width="14%">VKN/TCKN</th>
								<th width="36%">Unvan</th>
								<th width="6%">İşlemler</th>
							</tr>
							</thead>
							<tbody>
							{this.state.loading ?
								<tr>
									<td colSpan={15}>
										<ReactLoading type="spinningBubbles" style={{
											width: "70px",
											height: "70px",
											margin: "20px auto 0 auto",
											fill: "#888"
										}}/></td>
								</tr>
							:
							this.state.inboxList.map((inbox, index) =>
								<tr key={index} style={{backgroundColor:(inbox.success ? 'lightgreen' : '')}}>
									<td style={{margin:"0px"}}>{this.state.realIndex + (index+1)}</td>
									<td style={{fontWeight:'bold', fontSize:'12px', padding: "0px", margin: "0px", backgroundColor: "inherit", color: this.getRandomColor(this.state.inboxList[index].documentUuid)}}>{this.state.inboxList[index].documentId}</td>
									<td className={"form-group" + this.validateClass('cariCode_'+ index)}>
										{this.state.manual &&
										<input
											id={'cariCode_' + index}
											type="text"
											disabled={inbox.success}
											data-vlength="1,255"
											maxLength={255}
											className="form-control"
											value={inbox.cariCode}
											onChange={(e) => this.onChange({
												value: e.target.value,
												name: "cariCode"
											}, index)}/>
										}
										{!this.state.manual &&
										<Select.AsyncCreatable
											multi={false}
											wrapperStyle={{position: 'relative', zIndex: 9999}}
											className="select-control"
											ignoreAccents={false}
											id={'cariCode_' + index}
											value={{
												value: inbox.cariCode,
												label: inbox.cariCode
											}}
											onChange={(e) => e && this.onCariChange(e, index)}
											isLoading={true}
											autoload={false}
											cache={false}
											clearable={false}
											noResultsText="Kayıt bulunamadı."
											searchPromptText="Arama için en az 1 karakter giriniz."
											placeholder="Cari VKN/TCKN veya Kodu ile arama yapabilirsiniz"
											loadingPlaceholder="Yükleniyor..."
											filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
											onNewOptionClick={(option) => this.createCari(option, index)}
											promptTextCreator={(label) => "ERP Cari Listesine Ekle"}
											showNewOptionAtTop={false}
											arrowRenderer={this.arrowRenderer}
											onCloseResetsInput={false}
											loadOptions={(key) => readCustomer(key)}
										/>}
									</td>
									<td className={"form-group" + this.validateClass('vknTckn'+ index)}>
										<input
											id={'vknTckn_' + index}
											type="text"
											data-vlength="1,255"
											maxLength={255}
											className="form-control"
											value={inbox.vknTckn}
											onChange={(e) => this.onChange({
												value: e.target.value,
												name: "vknTckn"
											}, index)}/>
										{this.validateMessage('vknTckn_' + index) !== "" &&
										<UncontrolledTooltip placement="right"
															 target={'vknTckn_' + index}
															 delay={0}>
											{this.validateMessage('vknTckn_' + index)}
										</UncontrolledTooltip>}
									</td>
									<td className={"form-group" + this.validateClass('formattedName_'+ index)}>
										<input
										id={'formattedName_' + index}
										type="text"
										maxLength={255}
										className="form-control"
										value={inbox.formattedName}
										onChange={(e) => this.onChange({
											value: e.target.value,
											name: "formattedName"
										}, index)}/>
										{this.validateMessage('formattedName_' + index) !== "" &&
										<UncontrolledTooltip placement="right"
															 target={'formattedName_' + index}
															 delay={0}>
											{this.validateMessage('formattedName_' + index)}
										</UncontrolledTooltip>}
									</td>
									<td style={{margin:"0px", backgroundColor:''}}>
										{!inbox.status ?
											<button type="button"
													className="Btn edit"
													style={{background: (inbox.lineStatus ? 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))' :'linear-gradient(#ccc, #ccc)')}}
													onClick={() => this.setState({lineModal:true,selectedIndex:index})}
											>
											</button>:	this.getStatusRender(inbox.status)
										}
									</td>
								</tr>
							)}
							</tbody>
						</table>
					</div>
				</div>
				{this.state.lineModal &&
				<ERPLineModal
					modal={this.state.lineModal}
					documentUuid={this.state.inboxList[this.state.selectedIndex].documentUuid}
					year={this.props.year}
					title={this.state.inboxList[this.state.selectedIndex].documentId + " numaralı fatura kalemleri"}
					inboxLineList={this.state.inboxList[this.state.selectedIndex].inboxLineList}
					listener={this.setLine}
					toggleModal={() => this.setState({lineModal:false})}
				/>
				}
				{this.state.cariModal &&
				<CariModal
					cari={this.state.cari}
					modal={this.state.cariModal}
					listener={this.setCari}
					toggleModal={() => this.setState({cariModal:false})}
				/>
				}
			</DefaultModal>
		)
	}
}

export default SendToConnectorModal;